import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CircularProgress, Typography, Modal, Button } from "@material-ui/core";
import { toast, ToastContainer } from "react-toastify";
import { decryptData } from "../../../crypto";
import QpsyncNeet from "./QpsyncNeet";
import QpsyncJee from "./QpsyncJeeMains";
import QpsyncJeeAdvanced from "./QpsyncJeeAdvanced";
import useStyles from "./styles";

export default function Qpsync() {
    const { rowId } = useParams();
    const navigate = useNavigate();
    const classes = useStyles();
    const [examFormat, setExamFormat] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchExamDetails = async () => {
            try {
                const token = decryptData(sessionStorage.getItem("token"));
                if (!token) {
                    throw new Error("Session expired. Please log in again.");
                }
                const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (!res.ok) {
                    throw new Error(`Failed to fetch exam details: status ${res.status}`);
                }
                const json = await res.json();
                if (json && json.exam) {
                    const format = (json.exam.exam_format || "").trim().toLowerCase();
                    setExamFormat(format);
                } else {
                    throw new Error("Invalid exam details received.");
                }
            } catch (err) {
                console.error("Error fetching exam format in Qpsync wrapper:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchExamDetails();
    }, [rowId]);

    useEffect(() => {
        if (!loading && examFormat) {
            const format = examFormat.toLowerCase();
            const isMains = format.includes("jee main") || format.includes("jee mains");
            const isAdvanced = format.includes("jee advance") || format.includes("jee advanced");
            const isNeet = format.includes("neet");

            if (isAdvanced) {
                // toast.info("JEE Advanced Question Paper Sync is coming soon!");
            } else if (!isMains && !isNeet) {
                toast.error("Not a valid exam format");
            }
        }
    }, [loading, examFormat]);

    const uploadQuestions = async (payloadList, paperCode) => {
        const token = decryptData(sessionStorage.getItem("token"));
        if (!token) {
            throw new Error("Session expired. Please log in again.");
        }
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/add/sync?paper_code=${paperCode || ""}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ data: payloadList })
        });

        const json = await response.json();
        if (!response.ok || json.success === false) {
            throw new Error(json.message);
        }
        return json;
    };

    if (loading) {
        return (
            <Modal
                open={true}
                className={classes.modal}
                disableBackdropClick
            >
                <div className={classes.paperSmall}>
                    <div className={classes.loaderContainer} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px" }}>
                        <CircularProgress style={{ color: "#00577B", width: 50, height: 50 }} />
                        <Typography variant="body1" className={classes.text}>
                            Loading exam configuration...
                        </Typography>
                    </div>
                </div>
            </Modal>
        );
    }

    if (error) {
        return (
            <Modal
                open={true}
                onClose={() => navigate(`/admin/addquestion/${rowId}`)}
                className={classes.modal}
                disableBackdropClick
            >
                <div className={classes.paperSmall} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                    <Typography variant="h5" style={{ color: "#f44336", fontWeight: "bold" }}>
                        Error
                    </Typography>
                    <Typography variant="body1" className={classes.text}>
                        {error}
                    </Typography>
                    <div style={{ display: "flex", gap: "16px", width: "100%", justifyContent: "center", marginTop: "8px" }}>
                        <Button
                            variant="contained"
                            onClick={() => navigate(`/admin/addquestion/${rowId}`)}
                            style={{
                                textTransform: "none",
                                borderRadius: "8px",
                                backgroundColor: "#00577B",
                                color: "#fff",
                                width: "120px"
                            }}
                        >
                            Go Back
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }

    const formatLower = (examFormat || "").toLowerCase();
    const isJeeMains = formatLower.includes("jee main") || formatLower.includes("jee mains");
    const isJeeAdvanced = formatLower.includes("jee advance") || formatLower.includes("jee advanced");
    const isNeet = formatLower.includes("neet");

    if (isJeeMains) {
        return <QpsyncJee onUpload={uploadQuestions} />;
    } else if (isJeeAdvanced) {
        return <QpsyncJeeAdvanced onUpload={uploadQuestions} />;
        /*
        return (
            <>
                <ToastContainer position="top-right" autoClose={5000} style={{ zIndex: 99999 }} />
                <Modal
                    open={true}
                    onClose={() => navigate(`/admin/addquestion/${rowId}`)}
                    className={classes.modal}
                    disableBackdropClick
                >
                    <div className={classes.paperSmall} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                        <Typography variant="h5" style={{ color: "#00577B", fontWeight: "bold" }}>
                            Coming Soon
                        </Typography>
                        <Typography variant="body1" className={classes.text}>
                            JEE Advanced Question Paper Sync is currently under development and will be available soon.
                        </Typography>
                        <div style={{ display: "flex", gap: "16px", width: "100%", justifyContent: "center", marginTop: "8px" }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate(`/admin/addquestion/${rowId}`)}
                                style={{
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    backgroundColor: "#00577B",
                                    color: "#fff",
                                    width: "120px"
                                }}
                            >
                                Go Back
                            </Button>
                        </div>
                    </div>
                </Modal>
            </>
        );
        */
    } else if (isNeet) {
        return <QpsyncNeet onUpload={uploadQuestions} />;
    } else {
        return (
            <>
                <ToastContainer position="top-right" autoClose={5000} style={{ zIndex: 99999 }} />
                <Modal
                    open={true}
                    onClose={() => navigate(`/admin/addquestion/${rowId}`)}
                    className={classes.modal}
                    disableBackdropClick
                >
                    <div className={classes.paperSmall} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                        <Typography variant="h5" style={{ color: "#f44336", fontWeight: "bold" }}>
                            Unsupported Format
                        </Typography>
                        <Typography variant="body1" className={classes.text}>
                            Question Paper sync is not supported for exam format "{examFormat || "Not Selected"}".
                        </Typography>
                        <div style={{ display: "flex", gap: "16px", width: "100%", justifyContent: "center", marginTop: "8px" }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate(`/admin/addquestion/${rowId}`)}
                                style={{
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    backgroundColor: "#00577B",
                                    color: "#fff",
                                    width: "120px"
                                }}
                            >
                                Go Back
                            </Button>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}